import React from 'react';
import {Link as RouterLink} from "react-router-dom";

import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import CardActions from '@mui/material/CardActions';
import Button from "@mui/material/Button";
import {Chip} from "@mui/material";
import {lightGreen} from "@mui/material/colors";

const AccountProfile = ({user}) => {
    return (
        <Card>
            <CardContent>
                <Box
                    sx={{
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Avatar
                        variant="square"
                        src="/broken-image.jpg"
                        sx={{height: 64, mb: 2, width: 64, bgcolor: lightGreen[300]}}
                    />
                    <Typography
                        color="textPrimary"
                        gutterBottom
                        variant="h5"
                    >
                        {user.displayName}
                    </Typography>
                    <Typography
                        color="textSecondary"
                        variant="body2"
                    >
                        {user.email}
                    </Typography>
                </Box>
            </CardContent>
            <Divider>
                <Chip label="ACTIONS"/>
            </Divider>
            <CardActions disableSpacing sx={{display: "flex", flexDirection: "column"}}>
                <Button
                    color="primary"
                    fullWidth
                    variant="text"
                    component={RouterLink}
                    to={"/account"}
                >
                    Account Overview
                </Button>
                <Button
                    color="primary"
                    fullWidth
                    variant="text"
                    component={RouterLink}
                    to={"/account/change-password"}
                >
                    Change Password
                </Button>
                <Button
                    color="primary"
                    fullWidth
                    variant="text"
                >
                    Client List
                </Button>
                <Button
                    color="primary"
                    fullWidth
                    variant="text"
                >
                    Evv History
                </Button>
                <Button
                    color="primary"
                    fullWidth
                    variant="text"
                >
                    Manage Signatures
                </Button>
                <Button
                    color="primary"
                    fullWidth
                    variant="text"
                >
                    Contact Admin
                </Button>
            </CardActions>
        </Card>
    );
};

export default AccountProfile;